import { Component, input } from '@angular/core';

export type LoadingDotsSize = 'small' | 'medium';

@Component({
  selector: 'htx-loading-dots',
  standalone: true,
  templateUrl: './loading-dots.component.html',
  styleUrl: './loading-dots.component.scss'
})
export class LoadingDotsComponent {
  size = input<LoadingDotsSize>('small');
  ariaLabel = input<string>('Loading');
}
